export const MAIN_CLASS = 'ib-forgot-password-page';

export const BUTTON_CLASS = `${MAIN_CLASS}__button`;

export const TITLE_CLASS = `${MAIN_CLASS}__title`;
